import { getExerciseImageUrl } from "site/services/content-base-url";
import { parseLessonTranslationsPart, type LessonTranslations } from "site/services/lesson-translations";

export type LessonWordEntry = {
  id: number;
  arabic: string;
  russian: string;
  translations: LessonTranslations;
  audio: string | null;
  image: string | null;
};

function arabicFromZeptoContent(content: unknown): string {
  if (!Array.isArray(content) || !content.length) {
    return "";
  }
  const part = content[0];
  if (typeof part === "string") {
    return part.trim();
  }
  if (Array.isArray(part)) {
    return part
      .map((value) => String(value ?? "").trim())
      .filter(Boolean)
      .join("\n");
  }
  return "";
}

function translationsFromZeptoContent(content: unknown): LessonTranslations {
  if (!Array.isArray(content) || content.length < 2) {
    return parseLessonTranslationsPart(null);
  }
  return parseLessonTranslationsPart(content[1]);
}

/** Type-1 vocabulary rows from lesson zepto, in lesson order. */
export function collectLessonVocabularyEntries(
  zepto: unknown[] | null | undefined,
  audio: Record<string, string> | null | undefined,
  images: Record<string, string> | null | undefined,
): LessonWordEntry[] {
  if (!zepto?.length) {
    return [];
  }

  const out: LessonWordEntry[] = [];
  for (const row of zepto) {
    if (!Array.isArray(row) || Number(row[0]) !== 1) {
      continue;
    }
    const id = Number(row[2]);
    if (!Number.isFinite(id) || id <= 0) {
      continue;
    }
    const arabic = arabicFromZeptoContent(row[1]);
    if (!arabic) {
      continue;
    }
    const translations = translationsFromZeptoContent(row[1]);
    const audioPath = audio?.[String(id)]?.trim() || null;
    const imagePath = images?.[String(id)]?.trim() || null;
    out.push({
      id,
      arabic,
      russian: translations.ru,
      translations,
      audio: audioPath,
      image: imagePath ? getExerciseImageUrl(imagePath) : null,
    });
  }
  return out;
}
